import React from 'react';
import { LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';

interface TestimonialMetricProps {
  icon: LucideIcon;
  label: string;
  value: string;
  detail: string;
  color: string;
}

export const TestimonialMetric: React.FC<TestimonialMetricProps> = ({
  icon: Icon,
  label,
  value,
  detail,
  color
}) => {
  return (
    <div className="glass p-4">
      <div className="flex items-center space-x-2 mb-2">
        <Icon className={`w-4 h-4 ${color}`} />
        <span className="text-sm">{label}</span>
      </div>
      <div className={`text-2xl font-bold ${color}`}>{value}</div>
      <div className="text-xs text-gray-400">{detail}</div>
    </div>
  );
};